import { ExamState } from "../components/exam/context/examContext";

export const getCurrentItem = (state: ExamState) => {
  if (!state?.exam?.content?.forms?.[state.position.form]) {
    return;
  }

  const form = state.exam.content.forms[state.position.form];
  const section = form?.sections?.[state.position.section];
  const questionId = section?.questionIds?.[state.position.question];

  return (
    state.exam.questions?.find((q: any) => {
      return q.id === questionId;
    }) ?? undefined
  );
};
